/**
 * @Author: v_jppjpeng
 * @Date: 2024-03-01 03:21:21
 * @Explain: 下拉 + 输入
 */
import classNames from 'classnames';
import { SelectInputProps, SelectInput as TdSelectInput } from 'tdesign-react';
import { OptionListProps } from '../data.d';
import OptionList from '../optionList';

type PropsType = {} & SelectInputProps & OptionListProps;

function SelectInput(props: PropsType) {
  const {
    className,
    searchable,
    searchPlaceholder,
    allOption,
    multiple,
    options,
    value,
    customOption,
    onChange,
    onClick,
    onClose,
    popupProps,
  } = props;
  return (
    <TdSelectInput
      {...props}
      className={classNames(
        'default-td-select-input',
        {
          'allow-input': props.allowInput,
        },
        className,
      )}
      popupProps={{
        overlayClassName: 'default-td-select-input-popup',
        ...popupProps,
      }}
      panel={
        <OptionList
          searchable={searchable}
          allOption={allOption}
          multiple={multiple}
          options={options}
          value={value}
          searchPlaceholder={searchPlaceholder}
          customOption={customOption}
          onClose={() => {
            // setVisible(false);
            onClose?.();
          }}
          onChange={onChange}
          onClick={(val, item) => {
            onChange?.(val, item);
            onClick?.(val, item);
          }}
        />
      }
    />
  );
}

export default SelectInput;
